<div class="card card-nc" *ngIf="hasEntitlement('TAB_CARDORDER_SYSTEM')">
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Cards Ordered </span>
  </div>

  <div style="padding-top: 30px" class="card-body">
    <div class="form-group row">

    <div
      class="form-group col-md-2"  >
      <span class="pull-right save-panel"
            style="margin-top: -10px; margin-right: -15px;"  class="labelCommon">Start Date</span> <br />
      <div class="form-group">
        <div class="input-group">
          <input
            type="text"
            class="form-control reports-date-picker"
            name="dp1"
            [(ngModel)]="startDate"
            [maxDate]="endDate"
            (change)="changeDate()"
            (dateSelect)="changeDate()"
            ngbDatepicker
            #d1="ngbDatepicker"
          />
          <div class="input-group-append">
            <button class="btn-cal input-sm" (click)="d1.toggle()">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="form-group col-md-2" >
      <span class="labelCommon">End Date</span> <br />
      <div class="input-group">
        <input
          type="text"
          class="form-control reports-date-picker"
          name="dp2"
          [(ngModel)]="endDate"
          [minDate]="startDate"
          (change)="changeDate()"
          (dateSelect)="changeDate()"
          ngbDatepicker
          #d2="ngbDatepicker"
        />
        <div class="input-group-append">
          <button class="btn-cal input-sm" (click)="d2.toggle()">
            <i class="fa fa-calendar"></i>
          </button>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="spinner" class="row">
    <div class="col-md-6 offset-md-2">
      <div style="margin-left: 2rem">
        <span><i class="fa fa-spinner fa-4x fa-pulse"></i></span>
      </div>
    </div>
  </div>

  <div class="card-body-row">
    <form *ngIf="newShipForm" name="newShipForm" [formGroup]="newShipForm">
      <table *ngIf="cardOrders?.length" class="table table-striped table-bordered table-hover">
        <thead class="tableheading">
        <tr>
          <th class="text-center">Ordered Date</th>
          <th class="text-center">Type</th>
          <th class="text-center">Quantity</th>
          <th class="text-center">Expected Delivery Date</th>
          <th class="text-center">Request Status</th>
          <th class="text-center">Order Status</th>
          <th class="text-center">Location</th>
          <th class="text-center">Name</th>
          <th class="text-center">Check 2.0</th>
          <th class="text-center">Available Count</th>
        </tr>
        </thead>
        <tbody id="pairNewShip">
        <tr *ngFor="let cardOrder of cardOrders | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize" >
          <td id="requestDate">{{ cardOrder.requestDate | date: 'MMM dd, yyyy' }}</td>
          <td id="requestType">{{ cardOrder.requestType }} {{ cardOrder.cardType }}</td>
          <td id="orderCount"  align="right">{{ cardOrder.orderCount }}</td>
          <td id="sendDate">
            <ng-container *ngIf="cardOrder.trackingNumber != null">
              <a [href] = "'https://www.fedex.com/fedextrack/?action=track&tracknumbers=' + cardOrder.trackingNumber" target="_blank" rel="noopener noreferrer" >
              <span class="transactionHistText" style="color: #0000EE;text-decoration: underline;">{{
                  '#' + cardOrder.trackingNumber
                }}</span>
              </a>
            </ng-container>
            <ng-container *ngIf="cardOrder.trackingNumber == null">
                <span class="transactionHistText" >{{
                    cardOrder.expectedDate | date: 'MMM dd, yyyy'
                  }}</span>
            </ng-container>
          </td>
          <td id="requestStatus">{{ cardOrder.requestStatus }}</td>
          <td id="orderStatus">
            <ng-container *ngIf="cardOrder.orderStatus != null">
              <span class="transactionHistText" >{{
                  cardOrder.orderStatus
                }} </span>
            </ng-container>
            <ng-container *ngIf="cardOrder.orderStatus == null">
              <span class="transactionHistText">{{
                  'N/A'
                }}</span>
            </ng-container>
          </td>
          <td id="location">{{ cardOrder.location }}</td>
          <td id="name">{{ cardOrder.name }}</td>
          <td id="check20">{{ cardOrder.check20 }}</td>
          <td id="available" align="right">{{ cardOrder.cardType == 'Visitor' && cardOrder.requestType != 'EMV' ? 'N/A' : cardOrder.available}}</td>
        </tr>
        </tbody>
      </table>
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="cardOrders?.length">
      </ngb-pagination>
    </form>
  </div>
</div>
</div>
